
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showDropdown: false,
      avatarFailed: false,
    }
  },

  computed: {
    ...mapGetters('user', ['isAdmin']),

    // Auth0 users without a profile picture have no (or a broken) `picture`
    // claim, which rendered as a broken-image icon. Fall back to an initial.
    avatarSrc() {
      if (this.avatarFailed) return null
      return (this.$auth.user && this.$auth.user.picture) || null
    },

    initial() {
      const user = this.$auth.user || {}
      const source = user.name || user.email || '?'
      return source.trim().charAt(0).toUpperCase() || '?'
    },
  },

  methods: {
    goToLogin() {
      this.$router.push({ name: 'auth-login' })
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },
  },
}
